import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'
import actionFactory from 'Shared/hooks/actionFactory'
import { actions as localActionsF } from './local'

const adapter = createEntityAdapter()

const reducer = createSlice({
  name: 'actionTemplates',
  initialState: adapter.getInitialState(),
  reducers: {
    upsert: adapter.upsertOne,
    add: adapter.addOne,
    set: adapter.setOne,
    setAll: adapter.setAll,
    remove: adapter.removeOne,
  },
}).reducer

const actions = (dis, store, restClient) => {
  const localActions = localActionsF(dis, store, restClient)

  const factoryActions = actionFactory(dis, store, 'actionTemplate', {}, {}, {
    afterChange: () => localActions.setDirty(true)
  })

  return {
    ...factoryActions,
  }
}

export { reducer, actions }
export default { reducer, actions }
